<template>
    <div>
        <div class="block shadow">
            <div class="block__inner">
                <div
                    class="btn-block"
                    v-for="item in menu"
                    v-bind:key="item.icon"
                >
                    <router-link class="button" :to="{ name: item.name }">
                        <div class="icon">
                            <div :class="item.icon"></div>
                        </div>
                        <div>
                            {{ item.title }}
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="block__delete-wrapper">
                <Button
                    like_text
                    class="block__delete-btn"
                    @click="popupClickHandler"
                    >Удалить профиль</Button
                >
            </div>
        </div>
        <DeleteProfilePopup v-model="showDeletePopup" />
    </div>
</template>

<script>
import Button from '@/components/UI/Button';
import DeleteProfilePopup from '@/components/account/userCard/DeleteProfilePopup';
import routes, { section_extra } from './../../../routes/account-tabs';

export default {
    components: {
        Button,
        DeleteProfilePopup,
    },
    name: 'TabMore',
    data: () => ({
        showDeletePopup: false,
    }),
    computed: {
        menu() {
            return routes()
                .filter((v) => v.meta)
                .filter((v) => v.meta.section === section_extra)
                .filter((v) => !v.meta.canView || v.meta.canView())
                .map((v) => ({
                    name: v.name,
                    title: v.meta.title,
                    icon: v.meta.icon,
                }));
        },
    },
    methods: {
        popupClickHandler() {
            this.showDeletePopup = true;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/rem';

.block {
    background-color: #ffffff;
    border-radius: rem(10);
    &__inner {
        border-radius: 0.2rem;
        padding: rem(32) rem(32) 0 rem(32);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    @include on-mobile {
        width: 100%;
        position: fixed;
        display: block;
        z-index: 1;
        height: calc(100% - 90px);
        border-radius: mrem(10);
    }

    &__delete-btn {
        justify-content: flex-start;
        font-size: rem(14);
        font-weight: 600;
        padding: rem(0) rem(8);
        margin-top: rem(16);
        color: #ef627d !important;
        @include on-mobile {
            font-size: mrem(14);
            padding: mrem(0) mrem(8);
            margin-top: mrem(16);
        }
    }

    &__delete-wrapper {
        padding: 0 rem(32) rem(32) rem(32);
    }
}

.btn-block {
    flex: 0 50%;
    padding: 0.5rem;
    + .btn-block {
        margin-top: unset !important;
    }

    @include on-mobile {
        padding: 2rem 3rem;
        /*flex: 0 100%;*/
        display: block;
    }
}

.button {
    display: flex;
    border: 1px solid #9bb9ef;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 0.4rem 1rem;
    font-size: 0.8rem;
    font-family: 'Montserrat';
    cursor: pointer;
    justify-content: flex-start;
    color: #2a2626;
    font-weight: 500;

    @include on-mobile {
        font-size: 4rem;
        font-weight: 600;
        border: none;
    }
}
.button:hover {
    box-shadow: inset 0 0 3px 1px #9bb9ef;
}
.button > div {
    display: inline-block;
    vertical-align: middle;
}
.icon {
    display: inline-block;
    margin-right: 8px;
}
.icon > div {
    width: 1.5rem;
    height: 1.5rem;
    background-size: contain;
    vertical-align: middle;

    @include on-mobile {
        width: 5rem;
        height: 5rem;
        display: none;
    }
}
.icon .user {
    background-image: url(../../../assets/images/icons/user.png);
}
.icon .groups {
    background-image: url(../../../assets/images/icons/groups.png);
}
.icon .work {
    background-image: url(../../../assets/images/icons/work.svg);
}
.icon .claims {
    background-image: url(../../../assets/images/icons/claims.svg);
}
.icon .track {
    background-image: url(../../../assets/images/icons/track.png);
}
.icon .settings {
    background-image: url(../../../assets/images/icons/settings.svg);
}
.icon .reporting {
    background-image: url(../../../assets/images/icons/reporting.svg);
}

.icon .achievements {
    background-image: url(../../../assets/images/icons/achievements.svg);
}

.icon .vacancy {
    background-image: url(../../../assets/images/icons/vacancy.svg);
}
</style>
